import React from "react";

import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/core/styles";

const snackBarStyle = makeStyles({
  root: {
    "& div.MuiPaper-root.MuiSnackbarContent-root.MuiPaper-elevation6": {
      backgroundColor: (props) =>
        props.backgroundColor ? props.backgroundColor : "#ff6347",
      color: "#F3F3F3",
      minHeight: "70px",
    },
  },
});

export default (props) => {
  const classesSnackBar = snackBarStyle({
    backgroundColor: props.backgroundColor,
  });

  const { stateSnackBar, setStateSnackBar, fowardRef } = props;

  const { vertical, horizontal, open, message } = stateSnackBar;

  return (
    <Snackbar
      ref={fowardRef}
      className={classesSnackBar.root}
      anchorOrigin={{ vertical, horizontal }}
      open={open}
      onClose={() => setStateSnackBar({ ...stateSnackBar, open: false })}
      message={message}
      autoHideDuration={5000}
      key={vertical + horizontal}
      action={
        <React.Fragment>
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={() => setStateSnackBar({ ...stateSnackBar, open: false })}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </React.Fragment>
      }
    />
  );
};
